import * as actionTypes from './actionTypes'

// these top 3 are now probable redundant
export const setSelectedAccount = payload => {
    // console.log('[redux/actions/account.js] setSelectedAccount: action', payload)
    if (payload) {
        localStorage.setItem('selectedAccount', payload)
        return {
            type: actionTypes.UPDATE_SELECTED_ACCOUNT,
            selectedAccount: payload
        }
    }
}

export const setSelectedDevice = payload => {
    // console.log('[redux/actions/account.js] setSelectedDevice: action', payload)
    return {
        type: actionTypes.UPDATE_SELECTED_DEVICE,
        selectedDevice: payload
    }
}

export const setSelectedServiceOrder = payload => {
    // console.log('[redux/actions/account.js] setSelectedAccount: action', payload)
    return {
        type: actionTypes.UPDATE_SELECTED_SERVICEORDER,
        selectedServiceOrder: payload
    }
}

export const setSelected = obj => {
    if (obj.tyle === actionTypes.UPDATE_SELECTED_ACCOUNT) {
        localStorage.setItem('selectedAccount', obj.selectedAccount)
    }
    return obj
}
